import match from "autosuggest-highlight/match";
import parse from "autosuggest-highlight/parse";

function getNewClassName(newClassName) {
  if (!Array.isArray(newClassName)) return newClassName;

  return newClassName.filter((name) => name).join(" ");
}

export function appendClassName(baseClassName, newClassName) {
  if (!newClassName) return baseClassName || "";
  if (!baseClassName) return getNewClassName(newClassName) || "";
  return `${baseClassName} ${getNewClassName(newClassName)}`;
}

/*
Since Filter Values come in many different varieties, this helper
encapsulates the logic for determining how to show the label of that
filter in the UI.
*/
export function getFilterValueDisplay(filterValue) {
  if (filterValue === undefined || filterValue === null) return "";
  if (filterValue.hasOwnProperty("name")) return filterValue.name;
  return String(filterValue);
}

export function changeEmToMark(val = "") {
  return val
    ? val.replaceAll("<em>", "<mark>").replaceAll("</em>", "</mark>")
    : "";
}

export function markMatchedWords(searchTerm, val = "") {
  const v = val || "";
  const s = searchTerm || "";
  var matches = match(v || "", s, {
    insideWords: true,
    findAllOccurrences: true,
  });
  var parts = parse(v, matches);
  var hightlightedText = parts.reduce((acc, curr) => {
    acc += curr.highlight ? `<mark>${curr.text}</mark>` : curr.text;
    return acc;
  }, "");

  return hightlightedText;
}
